import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathLessThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMathLessThan"><Path fillRule="evenodd" clipRule="evenodd" d="M19.6059 5.76855L4.76807 12.0005L19.6059 18.2324L20.1868 16.8494L8.64171 12.0005L20.1868 7.15153L19.6059 5.76855Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathLessThan;
